import { render, staticRenderFns } from "./CoachArchiveButton.vue?vue&type=template&id=2bd7a5a3"
import script from "./CoachArchiveButton.vue?vue&type=script&lang=js"
export * from "./CoachArchiveButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports